import { Component, Fragment } from 'react';
import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import { formValueSelector } from 'redux-form';

import { Main, Filter } from 'Containers';
import { LoadingPage, DirtyWrapper } from 'Components';
import { CREATE_EDIT_PHYSICAL_FORM_NAME } from 'Common/FormEnum';
import {
  NewEditPhysicalEnum,
  SiteStatusEnum,
  TypeEnum,
  StatusEnum,
  SaveOptionsEnum,
} from 'Common/Constants/Enumeration/PhysicalEnum';
import {
  BidGroupEnum,
  CreateEditPhysicalEnum,
  FilterEnum,
} from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI, DATE_FORMAT_FOR_SERVER } from 'Common/Constants';
import {
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getStorageLocationForCurrentSite,
} from 'State/filters/actions';
import { submitForm, resetForm, destroyForm } from 'State/forms/actions';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { resetDirty } from 'State/dirtyTracking/actions';
import * as FilterSelectors from 'State/filters/selectors';
import { setYesNoDialogProps } from 'Components/dialogs/state/actions';
import { ReportGeneration } from 'Common/ObjectHelper';
import { isPreferenceDisabled } from 'Common/Security/SecurityHelpers';
import { PreferencesEnum } from 'Common/Security/PreferencesEnum';
import * as SecuritySelectors from 'Common/Security/state/selectors';

import { CreateEditPhysical } from '../../containers/createEditPhysical/CreateEditPhysical';
import { PreviewPhysical } from '../createEditPhysical/PreviewPhysical';
import { basicURL, getSaveObject, getValidData } from './../../helper';
import {
  CLOSE_PHYSICAL_WARNING,
  FUTURE_PHYSICAL_DATE_MESSAGE,
  DO_YOU_WANT_TO_CONTINUE_MESSAGE,
} from './../../helper/Constants';
import {
  getPhysicalItems,
  savePhysical,
  getPhysicalDetail,
  emptyItemList,
  emptyEditObject,
  clearPhysicalSubmitError,
  clearInvalidPreviewData,
  resetFilterOnClickOfPreviousPage,
  checkIncompletePhysicals,
  updatePhysical,
  getSiteWarningData,
  setIsLoadOnHandClicked,
  clearSiteWarningDataError,
} from '../../state/CreateEditPhysical/actions';
import * as Selectors from '../../state/CreateEditPhysical/selectors';

class CreateEditPhysicalWizardForm extends Component {
  static propTypes = {
    isDisabled: PropTypes.bool,
    fetchPhysicalItems: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    submitted: PropTypes.bool.isRequired,
    fetchingPhysicalDetail: PropTypes.bool.isRequired,
    selectedPhysicalDetail: PropTypes.object,
    checkIncompletePhysical: PropTypes.object,
    isLoadOnHandClicked: PropTypes.bool.isRequired,
    warningMessage: PropTypes.object,
    fetchSiteWarningDataLoading: PropTypes.bool.isRequired,
    bidGroupDataLoading: PropTypes.bool.isRequired,
    itemGroupDataLoading: PropTypes.bool.isRequired,
    storageLocationDataLoading: PropTypes.bool.isRequired,
    submitError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    physicalItemsLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    fetchPhysicalDetailError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    fetchPhysicalOnHandError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    siteWarningCheckForError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    siteWarningDataLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    checkIncompletePhysicalError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    bidGroupDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    itemGroupDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    storageLocationDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    physicalItemsInfo: PropTypes.array,
    physicalDT: PropTypes.string,
    site: PropTypes.string,
    submitForm: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    destroyForm: PropTypes.func.isRequired,
    getBidGroupForCurrentSite: PropTypes.func.isRequired,
    getItemGroupForCurrentSite: PropTypes.func.isRequired,
    getStorageLocationForCurrentSite: PropTypes.func.isRequired,
    getPhysicalItems: PropTypes.func.isRequired,
    savePhysical: PropTypes.func.isRequired,
    getPhysicalDetail: PropTypes.func.isRequired,
    emptyEditObject: PropTypes.func.isRequired,
    emptyItemList: PropTypes.func.isRequired,
    clearPhysicalSubmitError: PropTypes.func.isRequired,
    clearInvalidPreviewData: PropTypes.func.isRequired,
    resetFilterOnClickOfPreviousPage: PropTypes.func.isRequired,
    checkIncompletePhysicals: PropTypes.func.isRequired,
    updatePhysical: PropTypes.func.isRequired,
    getSiteWarningData: PropTypes.func.isRequired,
    setIsLoadOnHandClicked: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,
    clearSiteWarningDataError: PropTypes.func.isRequired,
    resetDirty: PropTypes.func.isRequired,
  };
  static defaultProps = {
    physicalItemsInfo: [],
    site: SiteStatusEnum.EMPTY,
    physicalDT: moment()
      .endOf('month')
      .format(DATE_FORMAT_FOR_UI),
    submitError: null,
    physicalItemsLoadingError: null,
    fetchPhysicalDetailError: null,
    fetchPhysicalOnHandError: null,
    siteWarningCheckForError: null,
    siteWarningDataLoadingError: null,
    checkIncompletePhysicalError: null,
    bidGroupDataError: null,
    itemGroupDataError: null,
    storageLocationDataError: null,
    warningMessage: null,
    selectedPhysicalDetail: null,
    checkIncompletePhysical: null,
  };
  static path = '/physical/:IsNewEdit/:PhysicalId';

  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      OpType: SaveOptionsEnum.SaveOnly,
      showDeliveryDateModal: false,
      values: null,
      resetPageOnDataChange: true,
      showWarningBeforeSave: false,
      showDialog: false,
      showSaveDialog: false,
    };
  }

  async componentDidMount() {
    const { IsNewEdit, PhysicalId } = this.props.match.params;
    this.props.getBidGroupForCurrentSite(BidGroupEnum.UnassignedAndAll);
    this.props.getItemGroupForCurrentSite();
    this.props.getStorageLocationForCurrentSite();
    if (IsNewEdit !== NewEditPhysicalEnum.NEW) {
      await this.props.getPhysicalDetail(PhysicalId);
      const { selectedPhysicalDetail } = this.props;
      if (selectedPhysicalDetail) {
        const filtersOptions = {
          SiteId: selectedPhysicalDetail[CreateEditPhysicalEnum.SiteId],
          DateTo: moment(
            selectedPhysicalDetail[CreateEditPhysicalEnum.PhysicalDT]
          ).format(DATE_FORMAT_FOR_SERVER),
          DateFrom: moment(
            selectedPhysicalDetail[CreateEditPhysicalEnum.PhysicalDT]
          ).format(DATE_FORMAT_FOR_SERVER),
        };
        if (!this.props.isDisabled) {
          await this.props.getPhysicalItems(
            filtersOptions,
            true,
            selectedPhysicalDetail[CreateEditPhysicalEnum.PhysicalItems]
          );
        }
      }
    }
    this.props.resetDirty();
  }

  componentDidUpdate(prevProps) {
    const { clearPhysicalSubmitError, checkIncompletePhysical } = this.props;
    const { showDialog, showDeliveryDateModal, showSaveDialog } = this.state;

    if (checkIncompletePhysical && checkIncompletePhysical.isError) {
      createToast(
        toastType.error,
        'Result',
        checkIncompletePhysical.message,
        !checkIncompletePhysical.isError
      );
    }
    if (
      errorToast(this.props, prevProps, 'siteWarningCheckForError') ||
      errorToast(this.props, prevProps, 'physicalItemsLoadingError') ||
      errorToast(this.props, prevProps, 'fetchPhysicalDetailError') ||
      errorToast(this.props, prevProps, 'bidGroupDataError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError') ||
      errorToast(this.props, prevProps, 'storageLocationDataError') ||
      errorToast(this.props, prevProps, 'submitError') ||
      errorToast(this.props, prevProps, 'fetchPhysicalOnHandError') ||
      errorToast(this.props, prevProps, 'siteWarningDataLoadingError') ||
      errorToast(this.props, prevProps, 'checkIncompletePhysicalError')
    ) {
      clearPhysicalSubmitError();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(
        toastType.success,
        'Success',
        'Physical has been saved',
        true
      );
      clearPhysicalSubmitError();
    }
    if (showDialog || showDeliveryDateModal) {
      this.props.setYesNoDialogProps({
        showDialog: true,
        title: showDialog ? 'Warning !' : 'Physical',
        question: showDialog
          ? DO_YOU_WANT_TO_CONTINUE_MESSAGE
          : FUTURE_PHYSICAL_DATE_MESSAGE,
        yesCallback: () => {
          showDialog
            ? this.handleShowWarningBeforeSave(true)
            : this.handleDialog(true);
        },
        noCallback: () => {
          showDialog
            ? this.handleShowWarningBeforeSave(false)
            : this.handleDialog(false);
        },
      });
    }
    if (showSaveDialog) {
      this.props.setYesNoDialogProps({
        showDialog: true,
        title: 'Warning',
        question: CLOSE_PHYSICAL_WARNING,
        yesCallback: () => {
          this.handleSaveConfirm();
        },
        noCallback: () => {
          this.handlSaveDialogNo();
        },
      });
    }
  }

  componentWillUnmount() {
    const {
      emptyItemList,
      selectedPhysicalDetail,
      emptyEditObject,
    } = this.props;
    this.completeReset();
    emptyItemList();
    if (selectedPhysicalDetail) {
      emptyEditObject();
    }
    this.clearTableSavedState();
  }
  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, basicURL, allTableStates, setTableStates, [
      TableNamesEnum.PHYSICAL_LIST_CREATE_EDIT_TABLE,
      TableNamesEnum.PHYSICAL_LIST_TABLE,
    ]);
  };

  completeReset = () => {
    this.props.destroyForm(CREATE_EDIT_PHYSICAL_FORM_NAME);
  };

  previousPage = () => {
    const {
      physicalItemsInfo,
      clearInvalidPreviewData,
      resetFilterOnClickOfPreviousPage,
    } = this.props;
    const data = getValidData(physicalItemsInfo);
    clearInvalidPreviewData(data);
    this.setState({ page: this.state.page - 1, resetPageOnDataChange: true });
    resetFilterOnClickOfPreviousPage();
  };

  isPreviewContainsValidData = () => {
    return Boolean(getValidData(this.props.physicalItemsInfo).length);
  };

  handleSaveOnly = e => {
    this.props.submitForm(CREATE_EDIT_PHYSICAL_FORM_NAME);
  };

  handlSaveDialogNo = () => {
    this.setState({ showSaveDialog: false });
  };

  handleSave = e => {
    this.setState({ showSaveDialog: true });
  };

  handleSaveConfirm = () => {
    this.setState({
      OpType: SaveOptionsEnum.SaveUpdateOnHandAndClose,
      showSaveDialog: false,
    });
    this.props.submitForm(CREATE_EDIT_PHYSICAL_FORM_NAME);
  };

  handleSubmit = values => {
    const { physicalDT } = this.props;
    if (moment(physicalDT).isAfter(moment().endOf('month'))) {
      this.setState({
        showDeliveryDateModal: true,
        values,
      });
    } else {
      this.setState({
        values,
      });
      this.handleIncompletePhysical();
    }
  };

  handleIncompletePhysical = () => {
    this.props.checkIncompletePhysicals().then(() => {
      !this.props.checkIncompletePhysicalError && this.checkWarningMessage();
    });
  };

  getMainProps = showDirtyConfirm => {
    const { page } = this.state;
    const { site, physicalDT, physicalItemsInfo, isDisabled } = this.props;
    let toolbox = {
      backButtonProps: { shown: true, path: this.getRootUrl() },
      rightButtons: [],
      shown: true,
    };
    !isDisabled &&
      (toolbox.rightButtons = [
        {
          content: 'Preview Physical Items',
          onClick: this.onPreviewItemsClick,
          disabled:
            site === NewEditPhysicalEnum.NEW ||
            !physicalDT ||
            !physicalItemsInfo ||
            !physicalItemsInfo.length,
        },
      ]);
    if (page === 2) {
      delete toolbox.backButtonProps;
      toolbox.rightButtons = [
        {
          content: 'Previous Page',
          onClick: this.previousPage,
        },
        {
          content: 'Save Update On Hand and Close',
          onClick: this.handleSave,
          disabled:
            !this.isPreviewContainsValidData ||
            isPreferenceDisabled(
              PreferencesEnum.ClosePhysicals,
              this.props.securityPreferences
            ),
        },
        {
          content: 'Save Only',
          onClick: this.handleSaveOnly,
          disabled: !this.isPreviewContainsValidData,
        },
        {
          content: 'Cancel',
          onClick: showDirtyConfirm,
        },
      ];
    }
    return {
      toolbox,
    };
  };

  getBreadCrumbs = () => {
    const { page } = this.state;
    const { IsNewEdit } = this.props.match.params;
    const { isDisabled } = this.props;
    let breadcrumbs = [
      {
        title: 'Physical',
        link: '/physical',
      },
      {
        title:
          IsNewEdit !== NewEditPhysicalEnum.EDIT
            ? 'Create New'
            : isDisabled
            ? 'View'
            : 'Edit',
        link: '',
      },
    ];
    if (page === 1) {
      breadcrumbs[1].link = '';
    }
    if (page === 2) {
      breadcrumbs.push({
        title: 'Physical Items',
        link: '',
      });
    }
    return breadcrumbs;
  };

  onPreviewItemsClick = () => {
    const {
      history,
      allTableStates,
      setTableStates,
      physicalItemsInfo,
      clearInvalidPreviewData,
    } = this.props;
    clearTableSavedState(history, '', allTableStates, setTableStates, [
      TableNamesEnum.PHYSICAL_LIST_CREATE_EDIT_TABLE,
    ]);
    const data = getValidData(physicalItemsInfo);
    clearInvalidPreviewData(data);
    this.setState({ page: this.state.page + 1, resetPageOnDataChange: true });
  };

  getCreatePageAndPreviewPage = () => {
    const { page } = this.state;
    const { IsNewEdit, PhysicalId } = this.props.match.params;
    const {
      fetchPhysicalItems,
      selectedPhysicalDetail,
      isDisabled,
      physicalItemsInfo,
      fetchPhysicalDetailError,
    } = this.props;
    let element = [];
    let render = false;
    let initialValues = {};
    if (IsNewEdit !== NewEditPhysicalEnum.NEW) {
      if (selectedPhysicalDetail) {
        render = true;
        initialValues = {
          [FilterEnum.GroupId_Bid]: 0,
          [FilterEnum.GroupId_Item]: 0,
          [FilterEnum.GroupId_Location]: 0,
          [CreateEditPhysicalEnum.Site]:
            selectedPhysicalDetail[CreateEditPhysicalEnum.SiteId],
          [CreateEditPhysicalEnum.PhysicalDT]: moment(
            selectedPhysicalDetail[CreateEditPhysicalEnum.PhysicalDT]
          ).format(DATE_FORMAT_FOR_UI),
          [CreateEditPhysicalEnum.Comments]:
            selectedPhysicalDetail[CreateEditPhysicalEnum.Comments],
          [CreateEditPhysicalEnum.PhysicalItemsInfo]:
            selectedPhysicalDetail[CreateEditPhysicalEnum.PhysicalItems],
        };
      } else if (fetchPhysicalDetailError) {
        render = true;
        initialValues = {
          [FilterEnum.GroupId_Bid]: 0,
          [FilterEnum.GroupId_Item]: 0,
          [FilterEnum.GroupId_Location]: 0,
          [CreateEditPhysicalEnum.Site]: SiteStatusEnum.EMPTY,
          [CreateEditPhysicalEnum.PhysicalDT]: moment()
            .endOf('month')
            .format(DATE_FORMAT_FOR_UI),
          [CreateEditPhysicalEnum.Comments]: '',
          [CreateEditPhysicalEnum.PhysicalItemsInfo]: [],
        };
      }
    } else {
      render = true;
      initialValues = {
        [FilterEnum.GroupId_Bid]: 0,
        [FilterEnum.GroupId_Item]: 0,
        [FilterEnum.GroupId_Location]: 0,
        [CreateEditPhysicalEnum.Site]: SiteStatusEnum.EMPTY,
        [CreateEditPhysicalEnum.PhysicalDT]: moment()
          .endOf('month')
          .format(DATE_FORMAT_FOR_UI),
        [CreateEditPhysicalEnum.Comments]: '',
        [CreateEditPhysicalEnum.PhysicalItemsInfo]: [],
      };
    }
    if (render) {
      page === 1
        ? element.push(
            <CreateEditPhysical
              key={`newEdit${page}`}
              initialValues={initialValues}
              IsNewEdit={IsNewEdit}
              PhysicalId={PhysicalId}
              isDisabled={isDisabled}
              fetchPhysicalItems={fetchPhysicalItems}
              resetPageOnDataChange={this.state.resetPageOnDataChange}
              onResetPageOnDataChange={this.onResetPageOnDataChange}
              setIsLoadOnHandClicked={this.props.setIsLoadOnHandClicked}
              isLoadOnHandClicked={this.props.isLoadOnHandClicked}
            />
          )
        : element.push(
            <PreviewPhysical
              key={`preview${page}`}
              initialValues={initialValues}
              IsNewEdit={IsNewEdit}
              PhysicalId={PhysicalId}
              onSubmit={this.handleSubmit}
              physicalItemsInfo={physicalItemsInfo}
              onResetPageOnDataChange={this.onResetPageOnDataChange}
              setIsLoadOnHandClicked={this.props.setIsLoadOnHandClicked}
            />
          );
    }
    return element;
  };

  getRootUrl = () => {
    return '/physical';
  };

  onCancelClick = () => {
    this.props.history.push('/physical');
  };
  resetScroll = () => this.props.scrollMainTo(0, 0);

  handleDialog = result => {
    if (result) {
      this.setState({ showDeliveryDateModal: false });
      this.handleIncompletePhysical();
    } else {
      this.setState({ showDeliveryDateModal: false });
    }
  };
  onResetPageOnDataChange = () => {
    this.setState({ resetPageOnDataChange: false });
  };
  saveUpdatePhysical = () => {
    const { selectedPhysicalDetail } = this.props;
    let physicalData = [];
    const { IsNewEdit, PhysicalId } = this.props.match.params;
    if (IsNewEdit === NewEditPhysicalEnum.NEW) {
      this.props.savePhysical(
        getSaveObject(
          this.state.values,
          this.state.OpType,
          PhysicalId,
          TypeEnum.TYPE,
          physicalData
        ),
        this.resetScroll
      );
    } else {
      physicalData =
        selectedPhysicalDetail[CreateEditPhysicalEnum.PhysicalItems];
      this.props.updatePhysical(
        getSaveObject(
          this.state.values,
          this.state.OpType,
          PhysicalId,
          TypeEnum.TYPE,
          physicalData
        ),
        this.resetScroll
      );
    }
  };
  checkWarningMessage = () => {
    const { site, physicalDT } = this.props;
    const { IsNewEdit, PhysicalId } = this.props.match.params;
    let tempSiteId = IsNewEdit === NewEditPhysicalEnum.NEW ? site : 0;
    const model = {
      [CreateEditPhysicalEnum.SiteId]: tempSiteId,
      [CreateEditPhysicalEnum.PhysicalDT]: moment(
        physicalDT,
        DATE_FORMAT_FOR_UI
      ).format(DATE_FORMAT_FOR_SERVER),
      [CreateEditPhysicalEnum.SaveOption]: 0,
      [CreateEditPhysicalEnum.PhysicalId]: PhysicalId,
    };
    this.props.getSiteWarningData(model).then(() => {
      const {
        warningMessage,
        siteWarningDataLoadingError,
        clearSiteWarningDataError,
      } = this.props;
      if (
        warningMessage &&
        this.state.OpType === SaveOptionsEnum.SaveUpdateOnHandAndClose
      ) {
        if (warningMessage.Title === TitleEnum.Warning) {
          if (warningMessage.Data.Message) {
            this.props.setYesNoDialogProps({
              showDialog: true,
              title: 'Warning !',
              question: warningMessage.Data.Message,
              yesCallback: () => {
                this.printOpenTransactionReport(true);
              },
              noCallback: () => {
                this.printOpenTransactionReport(false);
              },
            });
          }
        } else {
          if (!siteWarningDataLoadingError) {
            this.saveUpdatePhysical();
          } else {
            clearSiteWarningDataError();
            this.props.emptyItemList();
          }
        }
      } else {
        if (!siteWarningDataLoadingError) {
          this.saveUpdatePhysical();
        } else {
          clearSiteWarningDataError();
          this.props.emptyItemList();
        }
      }
    });
  };
  printOpenTransactionReport = result => {
    const { warningMessage } = this.props;
    if (result) {
      if (warningMessage.Data.OpenTransactionReport) {
        ReportGeneration(
          warningMessage.Data.OpenTransactionReport,
          'Open Transaction Report'
        );
      }
    }
    this.setState({ showWarningBeforeSave: false, showDialog: true });
  };

  handleShowWarningBeforeSave = result => {
    if (result) {
      this.saveUpdatePhysical();
    }
    this.setState({ showDialog: false });
  };
  render() {
    const {
      isReadOnly,
      fetchingDropDown,
      bidGroupDataLoading,
      itemGroupDataLoading,
      storageLocationDataLoading,
      submitting,
      fetchingPhysicalDetail,
    } = this.props;
    return fetchingDropDown ||
      bidGroupDataLoading ||
      itemGroupDataLoading ||
      storageLocationDataLoading ||
      submitting ||
      fetchingPhysicalDetail ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter title={''} breadcrumbs={this.getBreadCrumbs()} />
        <DirtyWrapper
          closeModalYesCallback={this.onCancelClick}
          isReadOnly={isReadOnly}
        >
          {showDirtyConfirm => (
            <Main
              {...this.getMainProps(showDirtyConfirm)}
              shouldNotUsePageWidth
            >
              {this.getCreatePageAndPreviewPage()}
            </Main>
          )}
        </DirtyWrapper>
      </Fragment>
    );
  }
}

const selector = formValueSelector(CREATE_EDIT_PHYSICAL_FORM_NAME);
const mapStateToProps = (state, props) => {
  const {
    PhysicalState: { createEditPhysical },
  } = state;
  const { IsNewEdit } = props.match.params;
  const isDisabled =
    createEditPhysical.selectedPhysicalDetail &&
    createEditPhysical.selectedPhysicalDetail.Status === StatusEnum.CLOSED &&
    IsNewEdit === NewEditPhysicalEnum.EDIT;

  return {
    physicalItemsInfo: selector(state, [
      CreateEditPhysicalEnum.PhysicalItemsInfo,
    ]),
    physicalDT: selector(state, [CreateEditPhysicalEnum.PhysicalDT]),
    site: selector(state, [CreateEditPhysicalEnum.Site]),
    allTableStates: getTableStates(state),

    isDisabled: isDisabled,
    fetchPhysicalItems: Selectors.getFetchPhysicalItems(state),
    loading: Selectors.getLoading(state),
    submitting: Selectors.getSubmitting(state),
    submitted: Selectors.getSubmitted(state),
    submitError: Selectors.getSubmitError(state),
    physicalItemsLoadingError: Selectors.getPhysicalItemsLoadingError(state),
    fetchPhysicalDetailError: Selectors.getFetchPhysicalDetailError(state),
    fetchPhysicalOnHandError: Selectors.getFetchPhysicalOnHandError(state),
    fetchingPhysicalDetail: Selectors.getFetchingPhysicalDetail(state),
    selectedPhysicalDetail: Selectors.getSelectedPhysicalDetail(state),
    checkIncompletePhysical: Selectors.getCheckIncompletePhysical(state),
    siteWarningCheckForError: Selectors.getSiteWarningCheckForError(state),
    isLoadOnHandClicked: Selectors.getIsLoadOnHandClicked(state),
    siteWarningDataLoadingError: Selectors.getSiteWarningDataLoadingError(
      state
    ),
    warningMessage: Selectors.getSiteWarningCheck(state),
    fetchSiteWarningDataLoading: Selectors.getFetchSiteWarningDataLoading(
      state
    ),
    checkIncompletePhysicalError: Selectors.getCheckIncompletePhysicalError(
      state
    ),

    bidGroupDataLoading: FilterSelectors.getBidGroupDataLoading(state),
    itemGroupDataLoading: FilterSelectors.getItemGroupDataLoading(state),
    storageLocationDataLoading: FilterSelectors.getStorageLocationDataLoading(
      state
    ),
    bidGroupDataError: FilterSelectors.getBidGroupDataError(state),
    itemGroupDataError: FilterSelectors.getItemGroupDataError(state),
    storageLocationDataError: FilterSelectors.getStorageLocationDataError(
      state
    ),
    securityPreferences: SecuritySelectors.getPreferences(state),
  };
};

const mapDispatchToProps = {
  submitForm,
  resetForm,
  destroyForm,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getStorageLocationForCurrentSite,
  getPhysicalItems,
  savePhysical,
  getPhysicalDetail,
  emptyEditObject,
  emptyItemList,
  clearPhysicalSubmitError,
  clearInvalidPreviewData,
  resetFilterOnClickOfPreviousPage,
  checkIncompletePhysicals,
  updatePhysical,
  getSiteWarningData,
  setIsLoadOnHandClicked,
  setTableStates,
  clearSiteWarningDataError,
  resetDirty,
  setYesNoDialogProps,
};
export const CreatePhysicalWizardForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateEditPhysicalWizardForm);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/containers/subpages/CreateEditPhysicalWizardForm.js